import { FC } from 'react';
import { useHookstate } from '@hookstate/core';
import {
    alias as aliasState,
    current,
    savePlayerAlias,
} from '../../stores/backend';
import { getQuery } from '../../lib/query';
import { AliasModal as AliasModalComponent } from '../../components/AliasModal';

export const AliasModal: FC = () => {
    const alias = useHookstate(aliasState);
    const $current = useHookstate(current);
    const { SESSIONID } = getQuery();

    const onConfirm = (newAlias: string) => {
        savePlayerAlias(newAlias, SESSIONID);
    };

    return (
        <AliasModalComponent
            isOpen
            saving={alias.saving.value}
            errorKey={alias.errorKey.value}
            initialValue={$current.player_alias.value || ''}
            onConfirm={onConfirm}
        />
    );
};
